import { ProgramNode } from "./ast";
import { parse } from "./parse";
import { tokenize } from "./tokenize";

export const toProgram = (source: string): ProgramNode => {
  const tokens = tokenize(source);
  return parse(tokens);
};
